<template>
  <div>
    <div :id="'posting_'+userData.userId">
      <div class="ta-r mb-10" style="margin-right: 1%;" v-if="!loading  && userData && userData.userId">
        <el-button size="mini" type="success" @click="doSyncAll" :loading="isSyncAllLoading">同步该用户所有帖子</el-button>

        <el-button
          size="mini"
          type="warning"
          :loading="isReCollecting"
          @click="doReCollects">重新采集</el-button>
      </div>
      <el-skeleton style="width:100%" class="flex wrap postListBox" :loading="loading" animated >
        <template slot="template">
          <div class="flex wrap postListBox">
            <div class="postBox" v-for="(item, index) in 5" :key="index">
              <el-card :body-style="{ padding: '0px' }">
                <el-skeleton-item variant="image" animated :throttle="500" style="width: 100%;height:200px" />
                <div style="padding: 14px;">
                  <el-skeleton-item variant="p" animated :throttle="500" style="width: 50%" />
                  <div style="display: flex; align-items: center; justify-items: space-between;">
                    <el-skeleton-item variant="text" animated :throttle="500" style="margin-right: 16px;" />
                    <el-skeleton-item variant="text" animated :throttle="500" style="width: 30%;" />
                  </div>
                </div>
              </el-card>
            </div>
          </div>
        </template>
        <template>
          
          <div v-for="(item, index) in list" :key="index" class="postBox">
            <el-card :body-style="{ padding: '0px' }">
              <Resources :list="item.resources"/>

              <div class="content-box">
                <div class="title">{{item.title}}</div>
                <div class="description">{{item.contents}}</div>
                <div class="bottom clearfix">
                  <time class="time">发布日期 {{ item.publishDate }}</time>
                </div>
                <div v-if="userData && userData.userId">
                  <el-divider></el-divider>
                  <div class="ta-r">
                    <template v-if="item.isWaiting">
                      <el-button round type="info" class="button" size="mini" disabled>正在创建发布任务中,3秒后更新..</el-button>
                    </template>
                    <template v-else>
                      <template v-if="item.autoSyncing">
                        <template v-if="!item.syncing">
                          <!-- <el-button round type="success" class="button" size="mini" :loading="isSyncIdLoading == item.postingId" @click="doSyncById(item)">提前发布</el-button> -->
                          <p>( 计划 <time class="time">{{ item.publishDate }}</time> 发布 )</p>
                        </template>
                        <el-button round type="info" v-else class="button" size="mini" :loading="isSyncIdLoading == item.postingId" disabled>已自动同步 {{item.publishDate}}</el-button>
                      </template>
                      <template v-else>
                        <el-button round type="success" v-if="!item.syncing" class="button" size="mini" :loading="isSyncIdLoading == item.postingId" @click="doSyncById(item)">发布 / 编辑</el-button>
                        <el-button round type="info" v-else class="button" size="mini" disabled>已手动同步 {{item.syncingAt}}</el-button>
                      </template>
                    </template>
                    
                  </div>
                </div>
              </div>
              
            </el-card>
          </div>
        </template>
      </el-skeleton>
    </div>
    

    <div class="ta-c mt-10 mb-10">
      <el-pagination
        background
        hide-on-single-page
        layout="prev, pager, next"
        @current-change="doChangePage"
        :page-size="size"
        :current-page="page"
        :total="total">
      </el-pagination>
    </div>

    <PostEdit :data.sync="currentData" :show.sync="isShowPostEdit" :doChangePage="doChangePage" />
    
  </div>
</template>

<script>
import PostEdit from '@/components/PostEdit';
import Resources from '@/components/Resources';
export default {
  name: 'PostList',
  components: {
    Resources,PostEdit
  },
  props: {
    userData:Object,
    collectUserId: String,
    collectType: String,
    extension: Object,
    updateTimer:{
      type: Number,
      default: null,
    },
  },
  data(){
    
    return {
      total:0,
      page:1,
      size:20,
      loading:true,
      nextLoading:true,
      list:[],
      isSyncAllLoading:false,
      isSyncIdLoading:0,
      isReCollecting:false,
      hasNext:true,
      afterCursor:"",
      isShowPostEdit:false,
      currentData:{}
    }
  },
  created () {
    this.load();
  },
  watch: {
    collectUserId(){
      this.load();
    },
    updateTimer(){
      this.load();
    }
  },
  methods:{
    doReCollects(){
      this.isReCollecting = true;
      this.request.post(`/api/v1/collectsTask/create?userId=${this.userData.userId}&updateOld=false`,{}).then(res=>{

        this.isReCollecting = false;
        if(!res){return ;}
        this.$message.success("操作成功!");
        this.load();
      }).catch(error=>{
        this.isReCollecting = false;
        this.$message.error("返回超时,请稍候再试!");
        console.log(error);
      });
    },
    checkSyncType(){
      if(!this.userData.slowLifeUserId){
        this.$message.warning("请先关联喜悦汇名人");
        return false;
      }
      // if(!this.extension.se || !this.extension.se.syncType || this.extension.se.syncType == 'NONE'){
      //   this.$message.warning("请先设置 自动发布配置");
      //   return false;
      // }
      return true;
    },
    doSyncAll(){
      if(!this.checkSyncType()){
        return ;
      }
      this.isSyncAllLoading = true;
      this.request.post(`/api/v1/postings/syncing/all`,{userId:this.userData.userId}).then(res=>{

        this.isSyncAllLoading = false;
        if(!res){return ;}
        this.$message.success("同步全部帖子成功!");
      }).catch(error=>{
        this.isSyncAllLoading = false;
        this.$message.error("返回超时,请稍候再试!");
        console.log(error);
      });
    },
    
  doSyncById(item){
      if(!this.checkSyncType()){
        return ;
      }
      this.currentData = item;
      this.isShowPostEdit = true;
      // if(!this.checkSyncType()){
      //   return ;
      // }
      // this.isSyncIdLoading = item.postingId;
      // var postingId = item.postingId;


      // this.request.post(`/api/v1/postings/syncing/${postingId}`,{postingId}).then(res=>{
      //   this.isSyncIdLoading = 0;
      //   if(!res){return ;}
      //   this.$message.success("创建发布帖子任务成功!");
      //   this.$set(item,'isWaiting',true)
      //   setTimeout(() => {
      //     this.doChangePage(this.page);
      //   }, 3000);
      // })
    },
    load(){
      this.loading = true;
      this.page = 1;
      this.afterCursor = "";
      this.list = [];
      this.hasNext = false;
      var url = `/api/v1/postings?collectType=${this.collectType}&userId=${this.userData.userId}&page=${this.page}&size=${this.size}`;
      this.getList(url);
    },
    getList(url){
      this.nextLoading = true;
      this.loading = true;
      this.request.get(url).then(res=>{
        this.loading = false;
        // this.list = [];
        this.afterCursor = "";
        if(!res){return ;}
        
        this.list = res.results;
        this.total = res.total;
        this.page = res.page;

        document.getElementById('posting_'+this.userData.userId).scrollIntoView();
        
        
      });
    },
    doChangePage(currentPage){
      this.page = currentPage;
      var url = `/api/v1/postings?collectType=${this.collectType}&userId=${this.userData.userId}&page=${currentPage}&size=${this.size}`;
      this.getList(url);
    },
  } 
}
</script>

<style lang="less" scoped>
.thumb-box{
  width:100%;
}
.content-box {
  padding: 14px;
  .title{
    font-size:14px;
  }
  .description{
    font-size:12px;
  }
  .bottom{
    margin-top:5px;
    margin-bottom:5px;
    .button{
      float: right;
    }
  }
}

.postListBox{
  .postBox{
    width:30%;
    margin-left:3%;
    margin-bottom:3%;  
  }
}
</style>
